<template>
    <m-layout>
      <div fill-height class="fill-height" style="width:100%">

        <v-card-title class="m-page__title">
          <span class="headline">Bookings</span>
          <v-btn icon class="mx-0" @click="onRefresh">
             <v-icon color="primary">refresh</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
         Total: {{ totalAmount | currency(true) }} ({{ total.price | currency(true) }})
        </v-card-title>

        <v-dialog v-model="dialog_ticket" width="400px">
          <img :src="ticketUrl" width="400px"/>
        </v-dialog>
        <m-confirm ref="confirm"></m-confirm>

        <m-booking-edit-form :form="form" :booking="selectedItem" :dialog="dialog_edit" @update="onUpdateBooking" @close="onCloseBooking"></m-booking-edit-form>
        <m-booking-details :booking="selectedItem" :dialog="dialog_details" @close="onCloseBooking"></m-booking-details>
        <m-booking-add-form :form="form" :dialog="dialog" @save="onSaveBooking" @close="onCloseBooking"></m-booking-add-form>

        <v-card style="max-width:100%; position:relative">
        <v-card-title>
          <v-btn
            absolute
            dark
            fab
            top
            right
            color="primary"
            @click.native.stop="onOpenDialog('dialog')">
            <v-icon>add</v-icon>
          </v-btn>
        <v-toolbar flat class="tm-toolbar pt-3">

          <v-menu
            :close-on-content-click="false"
            v-model="menu_date_start"
            transition="scale-transition"
            offset-y
            :nudge-right="40"
            min-width="290px"
          >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-on="on"
              label="Start date"
              v-model="dateFormatted_start"
              prepend-icon="event"
              readonly
            ></v-text-field>
          </template>

            <v-date-picker v-model="date_start" scrollable
            @input="dateFormatted_start = formatDate($event)"
            @change="onChangeDate"
            >
            </v-date-picker>
          </v-menu>


          <v-menu
            :close-on-content-click="false"
            v-model="menu_date_end"
            transition="scale-transition"
            offset-y
            :nudge-right="40"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
            <v-text-field
              v-on="on"
              label="End date"
              v-model="dateFormatted_end"
              prepend-icon="event"
              readonly
            ></v-text-field>
            </template>


            <v-date-picker v-model="date_end" scrollable
            @input="dateFormatted_end = formatDate($event)"
            @change="onChangeDate"
            :min="date_start"
            >
            </v-date-picker>
          </v-menu>
          <!-- <span v-if="total.price" class="ml-3 grey--text"> ({{ total.price | currency }})</span> -->
          <v-spacer></v-spacer>
          <v-text-field
          class="mr-5"
              append-icon="search"
              label="Search"
              single-line
              v-model="search"
            ></v-text-field>
          </v-toolbar>
          </v-card-title>

          <v-data-table
              :headers="headers"
              :items="filteredBookings"
              :options.sync="options"
              :sort-by="['date']"
              :sort-desc="[true]"
              :footer-props="{
                'items-per-page-options': [30, 40, {text:'All', value:-1}]
              }"
              dense
            >

          <template v-slot:body="{ items }">
            <tbody>
              <tr v-for="item in items" :key="item.name" :class="'status-' + item.status">

              <td >{{ item.id }}</td>
              <td >{{ item.ap_date }}</td>
              <td >{{ item.pick_time | formatTime }}</td>
              <td >{{ item.ap_time | formatTime }}</td>
              <td >{{ item.client_lastname + ' ' + item.client_firstname}}</td>
              <td >{{ item.driver_lastname }}</td>
              <td >{{ item.destination_name }}</td>
              <td >{{ item.type }}</td>
              <td >{{ item.price_driver | currency }}</td>
              <td class="text-center">{{ item.factuur}}</td>
              <td >{{ item.ap_waittime }}</td>
              <td class="icon-ticket">
                {{ item.ticket_price | currency }}
                  <v-icon v-if="item.ticket_price" class="pb-1"  color="primary" @click.stop="viewTicket(item)">receipt</v-icon>
              </td>

              <td class="text-center">
                <div v-if="item.certificateNeeded">
                  <v-icon small :color="item.certificateReceived ? 'green' : 'grey lighten-2'" >receipt</v-icon>
                </div>
              </td>
              <td >


              <v-menu>
                <template v-slot:activator="{ on }">
                <v-btn text small v-on="on" @click.prevent class="status" :class="'status-' + item.status">
                  {{ item.status | formatIndex(modes) }}
                </v-btn>
                </template>
                <v-list>
                  <v-list-item v-for="state in status" :key="state.value" @click.prevent="onStatusChange(item, state.value)">
                    <v-list-item-title :class="{ 'primary--text': item.status === state.value }">{{ state.text }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              </td>
              <td>
                <div style="display: flex">
                <v-btn icon class="mx-0" @click.stop="detailItem(item)">
                  <v-icon color="primary">visibility</v-icon>
                </v-btn>
                <v-btn icon class="mx-0" @click.stop="editItem(item)">
                  <v-icon color="primary">edit</v-icon>
                </v-btn>
                <v-btn icon class="mx-0" @click.stop="deleteItem(item)">
                  <v-icon color="primary">delete</v-icon>
                </v-btn>
                </div>
              </td>
              </tr>
              </tbody>
            </template>

            <template v-slot:item.status="{ item }">
              <v-menu>
                <template v-slot:activator="{ on }">
                <v-btn text @click.prevent v-on="on" class="status" :class="'status-' + item.status">
                  {{ item.status | formatIndex(modes) }}
                </v-btn>
                </template>
                <v-list>
                  <v-list-item v-for="state in status" :key="state.value" @click.prevent="onStatusChange(item, state.value)">
                    <v-list-item-title :class="{ 'primary--text': item.status === state.value }">{{ item.text }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
            <template v-slot:item.action="{ item }">
              <v-icon
                small
                class="mr-2"
                @click="editItem(item)"
              >
                edit
              </v-icon>
              <v-icon
                small
                @click="deleteItem(item)"
              >
                delete
              </v-icon>
            </template>
            <template slot="pageText" slot-scope="{ pageStart, pageStop, itemsLength }">
               {{ pageStart }} to {{ pageStop }} from {{ itemsLength }}
            </template>
          </v-data-table>
        </v-card>

      </div>
    </m-layout>
</template>

<script>
  import BookingMixin from '@/mixins/bookings'
  import { searchItems } from '@/utils/helpers'
  export default {
    name: 'bookings',
    mixins: [BookingMixin],
    data () {
      return {
        modes: ['pending', 'closed', 'unfounded', 'canceled'],
        status: [
          {text: 'pending', value: 0},
          {text: 'closed', value: 1},
          {text: 'unfounded', value: 2},
          {text: 'canceled', value: 3}
        ],
        search: '',
        options: {},
        headers: [
          {
            text: 'ID',
            align: 'left',
            width: '10',
            value: 'id'
          },
          { width: '20', text: '​Date', value: 'ap_date' },
          { width: '20', text: 'Before', value: 'pick_time' },
          { width: '20', text: '​Time', value: 'ap_time' },
          { width: '20', text: 'Client', value: 'client_lastname' },
          { width: '20', text: '​Driver', value: 'driver_lastname' },
          { width: '30', text: '​Destination', value: 'destination_name' },
          { width: '30', text: 'Type', value: 'type' },
          { text: 'Price', value: 'price_driver' },
          { width: '10', text: 'Factuur', value: 'factuur' },
          { text: 'Waits', value: 'ap_waittime' },
          { text: 'Parking', value: 'ticket_price' },
          { text: 'Certif', value: 'certificateNeeded' },
          { align: 'center', width: '10', text: 'Status', value: 'status' },
          { align: 'center', width: '10', text: 'Action', value: 'action' }
        ],
        items: [],
        total: {}
      }
    },
    methods: {
      onOpenDialog (dialog) {
        this[dialog] = true;
        console.log('open');
      },
      onStatusChange (item, value) {
        item.status = value;
        console.log('onStatusChange', item.id);
        this.updateStatusForm(item);
      },
      onChangeDate () {
        console.log('onChangeDate: ', this.date_start, this.date_end);
        this.getData();
        this.menu_date_start = this.menu_date_end = false;
      },
      updateStatusForm (data) {
        var fields = {
          status: data.status
        };
        console.log('updateBooking: ', fields);

        this.$http
        .put('api/booking/' + data.id, {fields: fields})
        .then(response => {
          console.log('updateStatusForm response ', response.data);
          this.getData();
        })
        .catch(function (error) {
          console.log('catch:', error);
        });
      },
      editItem (item) {
        this.resetBooking();
        this.selectedItem = this.items.find(i => i === item);
        this.dialog_edit = true;
        console.log('edit', this.selectedItem.id);
      },
      detailItem (item) {
        this.selectedItem = this.items.find(i => i === item);
        this.dialog_details = true;
        console.log('details', this.selectedItem);
      },
      deleteItem (item) {
        this.$refs.confirm.open('Delete', item.ap_date + ' ' + item.ap_time + ' for ' + item.client_lastname + ' ?').then((confirm) => {
          if (confirm) {
            this.$http
            .delete('api/booking/' + item.id)
            .then(response => {
              console.log('booking deleted', response.data);
              this.getData();
            })
            .catch(function (error) {
              console.log('catch:', error);
            });
          }
        });
      },
      getData () {
        var app = this;
        this.$http
        .post('service/booking/byDate', {
          startDate: app.date_start,
          endDate: app.date_end || app.date_start
        })
        .then(response => {
          app.items = response.data;
          app.total.price = 0;
          app.items.map(function (d) {
            var distance = d.json = JSON.parse(d.distance)
            d.date = d.ap_date
            d.ap_date = app.$options.filters.date(d.ap_date)
            d.price = d.price || distance.totals[d.type].price
            d.dist = distance.totals[d.type].distance
            d.duration = app.$options.filters.toTime(distance.totals[d.type].duration)
            // app.total.price += (d.price + d.waitprice); // full price
            app.total.price += app.calcprice(d);
          });
          app.options.page = 1;
          // console.log('bookings:', app.items);
        })
        .catch(function (error) {
          console.log('catch:', error);
        });
      },
      getDataById (id) {
        var app = this;
        this.$http
        .get('api/booking/' + id)
        .then(response => {
          app.items = response.data;
          app.items.map(function (item) {
            var distance = item.json = JSON.parse(item.distance)
            item.date = item.ap_date
            item.ap_date = app.$options.filters.date(item.ap_date)
            item.price = item.price || distance.totals[item.type].price
            item.dist = distance.totals[item.type].distance
            item.duration = app.$options.filters.toTime(distance.totals[item.type].duration)
          });
          this.editItem(app.items[0]);
        })
        .catch(function (error) {
          console.log('catch:', error);
        });
      },
      calcprice (d) {
        if (d.status >= 2) return 0;
        if (d.mutualAmount > 0) return d.mutualAmount;
        else return (d.price + d.waitprice);
      },
      isDirectLink (item) {
        item = item || this.$route.params.item || {}
        if (item.id && item.route === this.$route.name) {
          this.getDataById(item.id);
          this.$route.params.item = null;
        }
      }
    },
    computed: {
      filteredBookings () {
        return searchItems(this.items, this.search);
      },
      totalAmount () {
        return this.filteredBookings.reduce((sum, a) => sum + Number(a.price) + Number(a.waitprice), 0);
      }
    },
    created () {
      this.dateFormatted_start = this.formatDate(this.date_start);
      this.dateFormatted_end = this.formatDate(this.date_end);
      this.getData();
      this.$bus.$on('search:show', this.isDirectLink);
    },
    mounted () {
      this.isDirectLink();
    },
    beforeDestroy () {
      this.$bus.$off('search:show', this.isDirectLink);
    }
  }
</script>
<style lang="scss">
.hideMe {
  visibility: hidden;
}
.icon-ticket {
  white-space: nowrap;
  .icon {
    font-size: 14px;
    cursor: pointer;
  }
}
.tm-toolbar {
  &.v-toolbar {
    background-color: transparent !important;
  }
}
tr.status {
  &-1 {
    background:rgba(32, 151, 2, 0.1) !important;
  }
  &-2, &-3  {
    background:rgba(248, 1, 1, 0.1) !important;
  }
}

.v-btn.status {
  text-transform: none;
  color: grey;
  &-1 {
    color:rgba(32, 151, 2, 1) !important;
  }
  &-2, &-3 {
    color:rgba(248, 1, 1, 1) !important;
  }

}
.invoiceAddress {
  border: solid 1px #eee;
  padding: 0 20px 20px;
  .invoice-label {
    padding-top: 10px;
    color: #ccc;
  }
}
</style>



